import React, { useState } from 'react'
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';
import Popover from '@material-ui/core/Popover';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import AuditTrailViewer from '../AuditTrail';

const exportMenuItems = [
    {
        key: 'opportunity',
        label: 'Opportunity Data Only',
        description: 'Export core opportunity fields',
        icon: (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <rect x="3" y="2" width="14" height="16" rx="2" stroke="#3F51B5" strokeWidth="1.4" fill="none" />
                <line x1="6" y1="7" x2="14" y2="7" stroke="#3F51B5" strokeWidth="1.2" strokeLinecap="round" />
                <line x1="6" y1="10" x2="14" y2="10" stroke="#3F51B5" strokeWidth="1.2" strokeLinecap="round" />
                <line x1="6" y1="13" x2="11" y2="13" stroke="#3F51B5" strokeWidth="1.2" strokeLinecap="round" />
            </svg>
        ),
    },
    {
        key: 'bundle',
        label: 'Complete Opportunity Bundle',
        description: 'Contracts, Invoices & More',
        icon: (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <rect x="2" y="3" width="11" height="14" rx="1.5" stroke="#3F51B5" strokeWidth="1.3" fill="none" />
                <rect x="7" y="3" width="11" height="14" rx="1.5" stroke="#3F51B5" strokeWidth="1.3" fill="#fff" />
                <line x1="9.5" y1="7" x2="15.5" y2="7" stroke="#3F51B5" strokeWidth="1.1" strokeLinecap="round" />
                <line x1="9.5" y1="10" x2="15.5" y2="10" stroke="#3F51B5" strokeWidth="1.1" strokeLinecap="round" />
                <line x1="9.5" y1="13" x2="13.5" y2="13" stroke="#3F51B5" strokeWidth="1.1" strokeLinecap="round" />
            </svg>
        ),
    },
];

const ActionBarViewer = (props) => {
   const { isButtonEnable, isExport, isAuditTrail, handleAuditTrailDrawerToggle, auditTrailDrawerOpen, auditTrail, chartUniqueId, label, value, exportLabel, auditTrailLabel, blockState, handleExport, handleExportBundle } = props
   const [exportAnchorEl, setExportAnchorEl] = useState(null);

   const handleMenuItemClick = (key) => {
       setExportAnchorEl(null);
       if (key === 'opportunity') {
           handleExport(blockState?._id || blockState?.id, blockState);
       }
       if (key === 'bundle') {
           handleExportBundle(blockState?._id || blockState?.id, blockState);
       }
   };

    return (
        <div style={{ height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxSizing: 'border-box' }}>
            <div style={{ height: '40px', boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', boxSizing: 'border-box' }}>
                    <div style={{ height: '20px', width: '2px', backgroundColor: '#3F51B5' }}>

                    </div>
                    <Typography style={{ fontSize: '14px', fontWeight: '400', color: '#5F6071', fontStyle: 'normal', lineHeight: '24px' }}>{`${label} :`}</Typography>
                    <Typography style={{ fontSize: '14px', fontWeight: '400', color: '#2B2C35', fontStyle: 'normal', lineHeight: '24px' }}>{blockState?.[value]}</Typography>
                </div>
            </div>
            {
                isButtonEnable && (
                    <div style={{ height: '35px', boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
                        {
                            isExport && (
                                <>
                                    <Button
                                        style={{ backgroundColor: '#3F51B5', color: '#fff', border: '1px solid #3F51B5', borderRadius: '4px', height: '35px', padding: '0 16px', boxSizing: 'border-box', textTransform: 'none', fontSize: 13, fontWeight: 500 }}
                                        onClick={(e) => setExportAnchorEl(e.currentTarget)}
                                    >
                                        {exportLabel}
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ marginLeft: 6 }}>
                                            <path d="M4 6L8 10L12 6" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </Button>
                                    <Popover
                                        open={Boolean(exportAnchorEl)}
                                        anchorEl={exportAnchorEl}
                                        onClose={() => setExportAnchorEl(null)}
                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                        PaperProps={{
                                            style: {
                                                marginTop: 6,
                                                borderRadius: 8,
                                                boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
                                                border: '1px solid #E9EBF5',
                                                minWidth: 320,
                                                padding: '6px 0',
                                            },
                                        }}
                                    >
                                        {exportMenuItems.map((item, idx) => (
                                            <React.Fragment key={item.key}>
                                                <div
                                                    onClick={() => handleMenuItemClick(item.key)}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 12,
                                                        padding: '10px 16px',
                                                        cursor: 'pointer',
                                                        transition: 'background-color 0.15s',
                                                    }}
                                                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#F5F6FA'; }}
                                                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                                                >
                                                    <ListItemIcon style={{ minWidth: 'unset', width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 6, backgroundColor: 'rgba(63, 81, 181, 0.06)' }}>
                                                        {item.icon}
                                                    </ListItemIcon>
                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                                        <Typography style={{ fontSize: 13, fontWeight: 500, color: '#2B2C35', lineHeight: '20px' }}>
                                                            {item.label}
                                                        </Typography>
                                                        <Typography style={{ fontSize: 11, fontWeight: 400, color: '#78798E', lineHeight: '16px' }}>
                                                            {item.description}
                                                        </Typography>
                                                    </div>
                                                </div>
                                                {idx < exportMenuItems.length - 1 && (
                                                    <div style={{ height: 1, backgroundColor: '#F0F0F5', margin: '2px 12px' }} />
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </Popover>
                                </>
                            )
                        }
                        {
                            isAuditTrail && <Button
                                style={{ color: '#3F51B5', border: '1px solid #3F51B5', borderRadius: '4px', height: '35px', padding: '12px', boxSizing: 'border-box' }}
                                onClick={handleAuditTrailDrawerToggle}

                            >
                                {auditTrailLabel}
                            </Button>
                        }
                    </div>
                )
            }

            {
                isButtonEnable && isAuditTrail && (
                    <Drawer
                        anchor="right"
                        open={auditTrailDrawerOpen}
                        onClose={handleAuditTrailDrawerToggle}
                        PaperProps={{
                            style: {
                                width: '960px'
                            },
                        }}
                    >
                        <AuditTrailViewer {...props} auditTrail={auditTrail} chartUniqueId={chartUniqueId} handleAuditTrailDrawerToggle={handleAuditTrailDrawerToggle} />
                    </Drawer>
                )
            }

        </div>
    )
}

export default ActionBarViewer